<script setup lang="ts">
const {initialValue} = defineProps<{
  initialValue?: boolean,
}>()

const active: Ref<boolean> = ref(!!initialValue)
</script>

<template>
  <div class="menu menu--mobile">
    <v-icon
        v-if="!active"
        @click="active = true"
        size="29"
        icon="las la-bars"
    />

    <div v-if="active" class="menu__inner">
      <v-icon
          v-if="active"
          class="hidden-md-and-up" size="32"
          @click="active = false"
      >las la-times</v-icon>

      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.menu {
  text-align: center;

  &__inner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background: #1d1d1d;
    font-family: var(--font-primary);
  }

  :deep(.menu__items) {
    display: grid;
    align-content: center;
    height: 100%;
    color: white;
    padding: 32px 0;
    font-size: 17px;
    letter-spacing: 2px;
    z-index: 2;

    ul {
      li {
        position: relative;
        width: 100%;
        margin: 0;

        a {
          display: block;
          width: 100%;
          line-height: 50px;
          padding: 12px 0;
          transition: all 0.2s ease-in-out;
          transform: translateX(0);
          opacity: 1;
          font-size: 20px;

          &:hover {
            transform: translateX(5px);
            opacity: 0.5;
          }
        }

        &:before {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 140vw;
          background: #222;
          transition: transform 0.25s ease-in-out;
          content: '';
        }

        &:nth-child(odd):before {
          left: 0;
          transform: skew(45deg) translateX(-150vw);
        }

        &:nth-child(even):before {
          right: 0;
          transform: skew(45deg) translateX(150vw);
        }

        &:hover {
          &:nth-child(odd):before {
            transform: skew(45deg) translateX(-20vw);
          }
          &:nth-child(even):before {
            transform: skew(45deg) translateX(20vw);
          }
        }
      }
    }
  }

  :deep(.v-icon) {
    position: absolute;
    top: 22px;
    right: 24px;
    cursor: pointer;
    z-index: 3;
  }
}
</style>